import React from 'react';
import html2pdf from 'html2pdf.js';

class ImpresionDemanda {
  constructor(tramite) {
    this.tramite = tramite;
  }

  // ... (tus métodos auxiliares existentes se mantienen igual) ...
  formatFecha = (fechaString) => {
    if (!fechaString) return 'No especificada';
    try {
      const fecha = new Date(fechaString);
      return fecha.toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    } catch {
      return fechaString;
    }
  };

  formatFechaHora = (fechaString) => {
    if (!fechaString) return 'No especificada';
    try {
      const fecha = new Date(fechaString);
      return fecha.toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch {
      return fechaString;
    }
  };

  formatMoneda = (valor) => {
    if (!valor || valor === '0.00') return 'No especificado';
    return `L. ${parseFloat(valor).toLocaleString('es-HN')}`;
  };

  getColorEstado = (estado) => {
    const colores = {
      'En proceso': '#e0f2fe',
      'Cerrado': '#d1fae5',
      'Creada': '#fef3c7',
    };
    return colores[estado] || '#f3f4f6';
  };

  getColorTextoEstado = (estado) => {
    const colores = {
      'En proceso': '#0369a1',
      'Cerrado': '#065f46',
      'Creada': '#92400e',
    };
    return colores[estado] || '#374151';
  };

  getTipoDemandante = (tipo) => {
    const tipos = {
      1: 'Persona Natural',
      2: 'Persona Jurídica',
      3: 'Proveedor',
      4: 'Colaborador',
      5: 'Otros'
    };
    return tipos[tipo] || 'No definido';
  };

  getTipoDemanda = (tipo) => {
    const tipos = {
      1: 'Daños y Perjuicios',
      2: 'Ejecución de Garantías',
      3: 'Ejecución de Pagos',
      4: 'Ejecución de Títulos',
      5: 'Ejecutiva',
      6: 'Extra Contractual',
      7: 'Laboral',
      8: 'Monitorio',
      9: 'Nulidad de Instrumentos',
      10: 'Responsabilidad Contractual',
      11: 'Otros'
    };
    return tipos[tipo] || 'No definido';
  };

  getJuzgado = (juzgado) => {
    const juzgados = {
      1: 'Juzgado Civil',
      2: 'Juzgado Primero de Letras Departamental',
      3: 'Juzgado Primero de Letras Seccional',
      4: 'Ministerio Público',
      5: 'Otros'
    };
    return juzgados[juzgado] || 'No definido';
  };

  getMoneda = (moneda) => {
    const monedas = {
      1: 'Lempiras (HNL)',
      2: 'Dólares (USD)',
      3: 'Euros (EUR)'
    };
    return monedas[moneda] || 'No definido';
  };

  getResultadoCierre = (resultado) => {
    const resultados = {
      1: 'Favorable',
      2: 'Desfavorable',
      3: 'Conciliación',
      4: 'Proceso desistido o abandono de proceso',
      5: 'Otros'
    };
    return resultados[resultado] || 'No definido';
  };

  // Método para generar el contenido HTML del PDF con mejor paginación
  generarContenidoHTML() {
    const { tramite } = this;

    return `
      <div style="
        font-family: 'Arial', sans-serif;
        background: #fff;
        padding: 15mm;
        box-sizing: border-box;
        font-size: 12px;
        line-height: 1.4;
        color: #333;
      ">
        
        <!-- Encabezado - Siempre en primera página -->
        <div style="
          text-align: center; 
          border-bottom: 3px solid #19438C; 
          padding-bottom: 12px; 
          margin-bottom: 20px;
          page-break-after: avoid;
        ">
          <div style="
            background: #19438C; 
            color: white; 
            padding: 8px 0; 
            font-size: 16px; 
            font-weight: bold; 
            margin-bottom: 8px;
            border-radius: 4px;
          ">
            UNIDAD DE SERVICIOS LEGALES - REPORTE DE DEMANDA
          </div>
          <h2 style="margin: 4px 0; font-size: 14px; color: #19438C;">
            DEMANDA #${tramite.tramiteid}
          </h2>
          <div style="font-size: 10px; color: #666; margin-top: 4px;">
            <strong>Generado:</strong> ${new Date().toLocaleDateString('es-ES')}
          </div>
        </div>

        <!-- Estado del Trámite -->
        <div style="
          text-align: center; 
          margin-bottom: 20px;
          page-break-after: avoid;
        ">
          <span style="
            display: inline-block; 
            background: ${this.getColorEstado(tramite.estado)}; 
            color: ${this.getColorTextoEstado(tramite.estado)}; 
            padding: 6px 16px; 
            font-weight: bold; 
            font-size: 12px; 
            border-radius: 6px; 
            border: 2px solid ${this.getColorTextoEstado(tramite.estado)};
          ">
            ${tramite.estado || 'Estado no especificado'}
          </span>
        </div>

        <!-- Información General - Sección con control de paginación -->
        <div style="
          margin-bottom: 20px;
          page-break-inside: avoid;
        ">
          <div style="
            background: #edf2f7; 
            padding: 6px 10px; 
            border-radius: 4px; 
            margin-bottom: 6px;
            page-break-after: avoid;
          ">
            <h3 style="margin: 0; font-size: 12px; font-weight: bold; color: #2d3748;">
              📋 INFORMACIÓN GENERAL
            </h3>
          </div>
          <table style="
            width: 100%; 
            border-collapse: collapse; 
            font-size: 10px;
            page-break-inside: avoid;
          ">
            <tbody>
              <tr style="background-color: #f8fafc; page-break-inside: avoid;">
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px; font-weight: bold; width: 35%;">
                  Número de Trámite
                </td>
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px;">
                  ${tramite.tramiteid}
                </td>
              </tr>
              <tr style="page-break-inside: avoid;">
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px; font-weight: bold;">
                  Número de Demanda
                </td>
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px;">
                  ${tramite.numerodemanda || 'No especificado'}
                </td>
              </tr>
              <tr style="background-color: #f8fafc; page-break-inside: avoid;">
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px; font-weight: bold;">
                  Número de Expediente
                </td>
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px;">
                  ${tramite.numeroexpediente || 'No especificado'}
                </td>
              </tr>
              <tr style="page-break-inside: avoid;">
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px; font-weight: bold;">
                  Motivo de Demanda
                </td>
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px;">
                  ${tramite.motivodemanda || 'No especificado'}
                </td>
              </tr>
              <tr style="background-color: #f8fafc; page-break-inside: avoid;">
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px; font-weight: bold;">
                  Naturaleza
                </td>
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px;">
                  ${tramite.naturaleza === 1 ? 'A Favor' : tramite.naturaleza === 2 ? 'En Contra' : 'No definida'}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Fechas Importantes - Nueva sección con control de paginación -->
        <div style="
          margin-bottom: 20px;
          page-break-inside: avoid;
        ">
          <div style="
            background: #e6fffa; 
            padding: 6px 10px; 
            border-radius: 4px; 
            margin-bottom: 6px;
            page-break-after: avoid;
          ">
            <h3 style="margin: 0; font-size: 12px; font-weight: bold; color: #234e52;">
              📅 FECHAS IMPORTANTES
            </h3>
          </div>
          <table style="
            width: 100%; 
            border-collapse: collapse; 
            font-size: 10px;
            page-break-inside: avoid;
          ">
            <tbody>
              <tr style="background-color: #f8fafc; page-break-inside: avoid;">
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px; font-weight: bold; width: 35%;">
                  Fecha de Creación
                </td>
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px;">
                  ${this.formatFechaHora(tramite.fechacreacion)}
                </td>
              </tr>
              <tr style="page-break-inside: avoid;">
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px; font-weight: bold;">
                  Fecha de Presentación
                </td>
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px;">
                  ${this.formatFecha(tramite.fechapresentacion)}
                </td>
              </tr>
              <tr style="background-color: #f8fafc; page-break-inside: avoid;">
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px; font-weight: bold;">
                  Fecha de Asignación
                </td>
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px;">
                  ${this.formatFechaHora(tramite.fechaasignacion)}
                </td>
              </tr>
              <tr style="page-break-inside: avoid;">
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px; font-weight: bold;">
                  Fecha Máxima Contestación
                </td>
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px;">
                  ${this.formatFecha(tramite.fechamaximacontestacion)}
                </td>
              </tr>
              <tr style="background-color: #f8fafc; page-break-inside: avoid;">
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px; font-weight: bold;">
                  Fecha de Cierre
                </td>
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px;">
                  ${this.formatFechaHora(tramite.fechacierre)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Partes Involucradas - Otra sección -->
        <div style="
          margin-bottom: 20px;
          page-break-inside: avoid;
        ">
          <div style="
            background: #fffaf0; 
            padding: 6px 10px; 
            border-radius: 4px; 
            margin-bottom: 6px;
            page-break-after: avoid;
          ">
            <h3 style="margin: 0; font-size: 12px; font-weight: bold; color: #744210;">
              👥 PARTES INVOLUCRADAS
            </h3>
          </div>
          <table style="
            width: 100%; 
            border-collapse: collapse; 
            font-size: 10px;
            page-break-inside: avoid;
          ">
            <tbody>
              <tr style="background-color: #f8fafc; page-break-inside: avoid;">
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px; font-weight: bold; width: 35%;">
                  Demandante
                </td>
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px;">
                  ${tramite.nombredemandante || 'No especificado'}
                </td>
              </tr>
              <tr style="page-break-inside: avoid;">
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px; font-weight: bold;">
                  Tipo Demandante
                </td>
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px;">
                  ${this.getTipoDemandante(tramite.tipodemandante)}
                </td>
              </tr>
              <tr style="background-color: #f8fafc; page-break-inside: avoid;">
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px; font-weight: bold;">
                  Demandado
                </td>
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px;">
                  ${tramite.nombredemandado || 'No especificado'}
                </td>
              </tr>
              <tr style="page-break-inside: avoid;">
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px; font-weight: bold;">
                  Tipo de Demanda
                </td>
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px;">
                  ${this.getTipoDemanda(tramite.tipodemanda)}
                </td>
              </tr>
              <tr style="background-color: #f8fafc; page-break-inside: avoid;">
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px; font-weight: bold;">
                  Juzgado
                </td>
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px;">
                  ${this.getJuzgado(tramite.juzgado)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Información Financiera -->
        <div style="
          margin-bottom: 20px;
          page-break-inside: avoid;
        ">
          <div style="
            background: #f0fff4; 
            padding: 6px 10px; 
            border-radius: 4px; 
            margin-bottom: 6px;
            page-break-after: avoid;
          ">
            <h3 style="margin: 0; font-size: 12px; font-weight: bold; color: #22543d;">
              💰 INFORMACIÓN FINANCIERA
            </h3>
          </div>
          <table style="
            width: 100%; 
            border-collapse: collapse; 
            font-size: 10px;
            page-break-inside: avoid;
          ">
            <tbody>
              <tr style="background-color: #f8fafc; page-break-inside: avoid;">
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px; font-weight: bold; width: 35%;">
                  Moneda
                </td>
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px;">
                  ${this.getMoneda(tramite.moneda)}
                </td>
              </tr>
              <tr style="page-break-inside: avoid;">
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px; font-weight: bold;">
                  Tipo de Cambio
                </td>
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px;">
                  ${tramite.tipocambio || 'No especificado'}
                </td>
              </tr>
              <tr style="background-color: #f8fafc; page-break-inside: avoid;">
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px; font-weight: bold;">
                  Monto Estimación
                </td>
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px;">
                  ${this.formatMoneda(tramite.montoestimacion)}
                </td>
              </tr>
              <tr style="page-break-inside: avoid;">
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px; font-weight: bold;">
                  Monto Demandado
                </td>
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px;">
                  ${this.formatMoneda(tramite.montodemandado)}
                </td>
              </tr>
              <tr style="background-color: #f8fafc; page-break-inside: avoid;">
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px; font-weight: bold;">
                  Monto Provisión
                </td>
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px;">
                  ${this.formatMoneda(tramite.montoprovision)}
                </td>
              </tr>
              <tr style="page-break-inside: avoid;">
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px; font-weight: bold;">
                  Gastos Legales
                </td>
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px;">
                  ${this.formatMoneda(tramite.montogastoslegales)}
                </td>
              </tr>
              <tr style="background-color: #f8fafc; page-break-inside: avoid;">
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px; font-weight: bold;">
                  Valor Definitivo Conciliado
                </td>
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px;">
                  ${this.formatMoneda(tramite.valordefinitivoconciliado)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Información Adicional -->
        <div style="
          margin-bottom: 20px;
          page-break-inside: avoid;
        ">
          <div style="
            background: #faf5ff; 
            padding: 6px 10px; 
            border-radius: 4px; 
            margin-bottom: 6px;
            page-break-after: avoid;
          ">
            <h3 style="margin: 0; font-size: 12px; font-weight: bold; color: #44337a;">
              📝 INFORMACIÓN ADICIONAL
            </h3>
          </div>
          <table style="
            width: 100%; 
            border-collapse: collapse; 
            font-size: 10px;
            page-break-inside: avoid;
          ">
            <tbody>
              <tr style="background-color: #f8fafc; page-break-inside: avoid;">
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px; font-weight: bold; width: 35%;">
                  Observaciones
                </td>
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px;">
                  ${tramite.observaciones || 'No hay observaciones'}
                </td>
              </tr>
              <tr style="page-break-inside: avoid;">
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px; font-weight: bold;">
                  Acción Institucional
                </td>
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px;">
                  ${tramite.accioninstitucion || 'No especificada'}
                </td>
              </tr>
              <tr style="background-color: #f8fafc; page-break-inside: avoid;">
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px; font-weight: bold;">
                  Riesgo de Crédito
                </td>
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px;">
                  ${tramite.riesgocredito === 1 ? 'Sí' : tramite.riesgocredito === 2 ? 'No' : 'No definido'}
                </td>
              </tr>
              <tr style="page-break-inside: avoid;">
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px; font-weight: bold;">
                  Resultado de Cierre
                </td>
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px;">
                  ${this.getResultadoCierre(tramite.resultadocierre)}
                </td>
              </tr>
              <tr style="background-color: #f8fafc; page-break-inside: avoid;">
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px; font-weight: bold;">
                  Descripción de Cierre
                </td>
                <td style="border: 1px solid #cbd5e1; padding: 5px 6px;">
                  ${tramite.descripcioncierre || 'No especificada'}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pie de página -->
        <div style="
          text-align: center; 
          font-size: 9px; 
          color: #718096; 
          margin-top: 25px; 
          padding-top: 12px; 
          border-top: 1px solid #e2e8f0;
          page-break-before: avoid;
        ">
          <div style="margin-bottom: 4px;">
            Documento generado automáticamente por el Sistema de Gestión de Unidad de servicios legales
          </div>
          <div>© ${new Date().getFullYear()} - Todos los derechos reservados</div>
        </div>

      </div>
    `;
  }

  // Método mejorado para generar PDF con mejor control de paginación
  generarPDF() {
    const contentHTML = this.generarContenidoHTML();
    
    const element = document.createElement('div');
    element.innerHTML = contentHTML;

    const options = {
      margin: [10, 10, 10, 10], // [top, left, bottom, right] en mm
      filename: `Demanda_${this.tramite.tramiteid}_${new Date().toISOString().split('T')[0]}.pdf`,
      image: { 
        type: 'jpeg', 
        quality: 0.98 
      },
      html2canvas: { 
        scale: 2,
        useCORS: true,
        logging: false,
        letterRendering: true,
        allowTaint: true
      },
      jsPDF: { 
        unit: 'mm', 
        format: 'a4', 
        orientation: 'portrait',
        compress: true
      },
      pagebreak: { 
        mode: ['avoid-all', 'css', 'legacy'] 
      }
    };

    // Configuración adicional para mejor paginación
    const worker = html2pdf()
      .set(options)
      .from(element)
      .toPdf()
      .get('pdf')
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          pdf.setFontSize(8);
          pdf.setTextColor(150);
          pdf.text(
            `Página ${i} de ${totalPages}`,
            pdf.internal.pageSize.getWidth() / 2,
            pdf.internal.pageSize.getHeight() - 10,
            { align: 'center' }
          );
        }
      });

    html2pdf()
      .set(options)
      .from(element)
      .save();
  }
}

export default ImpresionDemanda;